import React from 'react';
import { motion } from 'framer-motion';
import { FileTextIcon, ZapIcon, MapPinIcon, BookOpenIcon, CakeIcon, ShieldCheckIcon, LockIcon, CreditCardIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
const chips = [{
  icon: FileTextIcon,
  label: '100% PDF'
}, {
  icon: ZapIcon,
  label: 'Acceso en 5 min'
}, {
  icon: MapPinIcon,
  label: 'Para Argentina'
}, {
  icon: BookOpenIcon,
  label: '12 Tomos'
}, {
  icon: CakeIcon,
  label: 'Cumpleaños Infantiles'
}];
const trust = [{
  icon: ShieldCheckIcon,
  label: 'Garantía 7 días'
}, {
  icon: LockIcon,
  label: 'Pago seguro'
}, {
  icon: CreditCardIcon,
  label: 'Mercado Pago'
}, {
  icon: ZapIcon,
  label: 'Acceso inmediato'
}];
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-83" data-mp="nbyir4alzley">
      <div className="mx-auto max-w-4xl px-5 pt-[35px] pb-[5px] text-center sm:pt-16" data-id="element-84" data-mp="3d2l9jc5qb50p">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="mt-[-25px] mb-[-25px] text-[12px] font-extrabold uppercase tracking-[0.25em] text-iris-soft" data-id="element-85" data-mp="3825yir8x69lw">
          🎉 Sigma Smart™
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="pt-[34px] pb-[33px] text-center font-[Cinzel,_serif] text-[28px] font-[800] tracking-tight sm:text-7xl text-[#FFFF] bg-[#0000]" data-id="element-86" data-mp="399bbnoze1fwi">
          Tu cumpleaños infantil
          <br data-id="element-87" data-mp="359j6lm97drvw" />
          <span className="text-[#A78BFA]" data-id="element-88" data-mp="35a2ial89fk1h">resuelto desde hoy</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2
      }} className="relative mx-auto mt-[-10px] mb-[-10px] w-full max-w-md pb-[19px]" data-id="element-89" data-mp="2qleq8oxmhsga">
          <div className="absolute inset-0 -z-10 mx-auto h-72 w-72 translate-y-6 rounded-full bg-iris/30 blur-3xl" data-id="element-90" data-mp="2lla9cxssyvpj" />
          <img src="https://cdn.magicpatterns.com/uploads/7A7U2wwgedDFbYewr8uowE/ChatGPT_Image_29_jul_2026,_18_05_43.png" alt="MEGAPACK FIESTA ÉPICA — la guía completa para cumpleaños infantiles" className="animate-floaty mx-auto max-w-[340px] rounded-2xl object-contain w-[250px] h-[250px]" data-id="element-91" data-mp="s333h94hagvf" />
        </motion.div>

        <motion.h2 initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mx-auto mt-[-2px] mb-[-2px] max-w-2xl pt-[0px] pb-[0px] text-[16px] font-bold text-iris-soft sm:text-xl" data-id="element-92" data-mp="deq6c8tnmrzc">
          MEGAPACK FIESTA ÉPICA — La Guía N°1 para Cumpleaños Infantiles en Argentina
        </motion.h2>

        <div className="mt-9" data-id="element-93" data-mp="x032x16toldk">
          <CTAButton data-id="element-94" data-mp="x37c6cz5a7b3">Quiero el MegaPack ahora</CTAButton>
          <p className="mx-auto mt-4 max-w-2xl pt-[15px] text-[14px] text-white/70 sm:text-lg" data-id="element-95" data-mp="3lt740mm25js5">
            Decoración + Presupuesto + Juegos + Animación + Mesa Dulce + Proveedores listos para
            aplicar. Sin improvisar. Sin gastar de más. Sin volverse locos.
          </p>
          <div className="mt-7 flex flex-wrap justify-center gap-2.5 pt-[7px]" data-id="element-96" data-mp="21aehzejeah9k">
            {chips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 rounded-full border border-white/10 bg-white/5 px-3.5 py-1.5 text-xs font-semibold text-white/80" data-id="element-97" data-mp="2697ogn09l808">
                <Icon className="h-3.5 w-3.5 text-iris-soft" data-id="element-98" data-mp="2g1wwf7wlw3qt" />
                {label}
              </span>)}
          </div>
          <p className="mt-4 pt-[7px] text-sm font-semibold text-white/50" data-id="element-99" data-mp="2ozz3a430tqm0">
            12 Tomos · 5 Bonos · 100+ páginas · Todo resuelto.
          </p>
        </div>

        <div className="mt-[10px] mb-[10px] flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-white/50" data-id="element-100" data-mp="2txhbttd4m3th">
          {trust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-101" data-mp="znn6488t04xc">
              <Icon className="h-4 w-4 text-azure" data-id="element-102" data-mp="4a2y3uflxs4d" />
              {label}
            </span>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.05
      }} className="mt-[18px] mb-[18px] inline-flex items-center gap-2 rounded-full border border-azure/40 bg-azure/10 px-4 pt-[4px] pb-[4px] text-xs font-bold uppercase tracking-wide text-azure" data-id="element-103" data-mp="3vhf9ttxq1dcw">
          🔥 Oferta de lanzamiento — el precio cierra pronto y no vuelve
        </motion.div>
      </div>
    </header>;
}